import React, { useState } from 'react';
import AvatarUploadModal from '../modals/AvatarUploadModal';
import { getAvatarUrl } from '../../utils/avatarUtils';
import './AvatarSection.css';

const AvatarSection = ({ userData, user, onAvatarUpdate }) => {
  const [showUploadModal, setShowUploadModal] = useState(false);

  const handleUploadSuccess = (updatedUser) => {
    onAvatarUpdate(updatedUser);
    setShowUploadModal(false);
  };

  const avatarUrl = getAvatarUrl(userData, user);

  return (
    <div className="avatar-section">
      {avatarUrl && (
        <div className="profile-picture-container">
          <img
            src={avatarUrl}
            alt={`${userData?.name || user?.name || 'User'} profile`}
            className="profile-picture"
            onError={(e) => {
              e.target.style.display = 'none';
              console.warn('Failed to load profile picture');
            }}
          />
        </div>
      )}

      <button
        onClick={() => setShowUploadModal(true)}
        className="btn-change-avatar"
      >
        Change Avatar
      </button>

      {showUploadModal && (
        <AvatarUploadModal
          onClose={() => setShowUploadModal(false)}
          onSuccess={handleUploadSuccess}
        />
      )}
    </div>
  );
};

export default AvatarSection;